.biel-input-options-container {
  display: flex;
  position: relative;
  margin-left: 10px;
  width: fit-content;
  padding-top: 10px;
  gap: 10px;
}

@media (max-width: 768px) {
  .biel-input-options-container {
    display: none;
  }
}

/* Dropdown content styles */
.biel-input-options__dropdown-content {
  display: flex;
  flex-direction: column;
  min-width: 240px;
}

.biel-input-options__dropdown-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  padding: 12px 32px 12px 16px;
  background: none;
  border: none;
  color: var(--biel-dropdown-text-color);
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
}

@media (hover: hover) {
  .biel-input-options__dropdown-item:hover {
    background-color: var(--biel-dropdown-hover-bg-color);
  }
}

.biel-input-options__dropdown-item:focus {
  outline: none;
  background-color: var(--biel-dropdown-hover-bg-color);
}

.biel-input-options__dropdown-item:not(:last-child) {
  border-bottom: 1px solid var(--biel-dropdown-border-color);
}

.biel-input-options__dropdown-item--selected {
  background-color: var(--biel-dropdown-selected-bg-color);
}

@media (hover: hover) {
  .biel-input-options__dropdown-item--selected:hover {
    background-color: var(--biel-dropdown-selected-hover-bg-color);
  }
}

.biel-input-options__dropdown-checkmark {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.biel-input-options__dropdown-title {
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--biel-dropdown-text-color);
}

.biel-input-options__dropdown-description {
  font-size: 0.85em;
  color: var(--biel-dropdown-text-secondary-color);
}

